import validator from "validator";
import { isUndefined } from "./is-null-or-undefined.js";
const { stripLow, trim } = validator;
/**
 * Parses and sanitizes an unknown value into a string
 * The string is trimmed and all low characters are removed
 */
export function parseAndSanitizeString(value) {
    if (isUndefined(value)) {
        return value;
    }
    if (typeof value == "function") {
        return undefined;
    }
    return stripLow(trim(String(value)));
}
/**
 * Parses and sanitizes an unknown value into a string without trimming
 * Only removes low characters, preserves leading/trailing spaces
 */
export function parseAndSanitizeStringNoTrim(value) {
    if (isUndefined(value)) {
        return value;
    }
    if (typeof value == "function") {
        return undefined;
    }
    return stripLow(String(value));
}
